<section [class.active]="_publicationMethod === 'email'">
  <p class="description">
    {{ 'common.bukTicketIssuerComponent.messages.formDescription' | translate }}
  </p>
  <div class="flex-box">
    <app-email-ticket-form
      class="form"
      [senderInfo]="senderInfo"
      [gaTrackingId]="gaTrackingId"
      [isUnlimitedTicket]="isUnlimitedTicket"
      (focusChange)="focusedInput = $event"
      (validityChange)="formInvaild = !$event"
      (formChange)="updateTicketData()"
      #emailTicketForm
    ></app-email-ticket-form>
    <app-hr class="hr"></app-hr>
    <app-email-ticket-preview
      class="preview"
      [ticketData]="ticketData"
      [contents]="contents"
      [contentsType]="contentsType"
      [focusedInput]="focusedInput"
      [isUnlimitedTicket]="isUnlimitedTicket"
    ></app-email-ticket-preview>
  </div>
</section>

<section [class.active]="_publicationMethod === 'link'">
  <div class="flex-box">
    <app-link-ticket-form
      class="form"
      [isUnlimitedTicket]="isUnlimitedTicket"
      (validityChange)="formInvaild = !$event"
      (formChange)="updateTicketData()"
      #linkTicketForm
    ></app-link-ticket-form>
    <app-hr class="hr"></app-hr>
    <app-link-ticket-preview class="preview"></app-link-ticket-preview>
  </div>
</section>

<div class="buttons">
  <button
    mat-raised-button
    color="primary"
    class="publish-button"
    [disabled]="disableIssue || formInvaild || credit === 0"
    (click)="onIssueTicketClick()"
  >
    <span> {{ 'common.actions.publish' | translate }}</span>
  </button>
</div>
